import * as ALARMS from '../alarms/alarms.constants';
import { AlarmList, Alarm } from '../../models';

/** LOAD */
export function loadAlarms() {
    return { type: ALARMS.ALARMS_LOAD };
}

export function loadAlarmsSuccess(data: AlarmList) {
    return { type: ALARMS.ALARMS_LOAD_SUCCESS, payload: data };
}

export function loadAlarmsByIdentifierSuccess(data: AlarmList) {
    return { type: ALARMS.ALARMS_LOAD_SUCCESS, payload: data };
}

export function loadAlarmsError(error: any) {
    return { type: ALARMS.ALARMS_LOAD_ERROR, payload: error };
}

export function loadAlarmsByIdentifierError(error: any) {
    return { type: ALARMS.ALARMS_LOAD_ERROR, payload: error };
}

export function loadAlarm() {
    return { type: ALARMS.ALARM_LOAD };
}

export function loadAlarmSuccess(data: AlarmList) {
    return { type: ALARMS.ALARM_LOAD_SUCCESS, payload: data };
}

export function loadAlarmError(error: any) {
    return { type: ALARMS.ALARM_LOAD_ERROR, payload: error };
}


/** ADD */
export function addAlarm() {
    return { type: ALARMS.ALARM_ADD };
}

export function addAlarmSuccess(data: AlarmList) {
    return { type: ALARMS.ALARM_ADD_SUCCESS, payload: data };
}

export function addAlarmError(error: any) {
    return { type: ALARMS.ALARM_ADD_ERROR, payload: error };
}

export function addAlarms() {
    return { type: ALARMS.ALARMS_ADD };
}

export function addAlarmsSuccess(data: AlarmList) {
    return { type: ALARMS.ALARMS_ADD_SUCCESS, payload: data };
}

export function addAlarmsError(error: any) {
    return { type: ALARMS.ALARMS_ADD_ERROR, payload: error };
}


/** UPDATE */
export function updateAlarm() {
    return { type: ALARMS.ALARM_UPDATE };
}

export function updateAlarmSuccess(data: AlarmList) {
    return { type: ALARMS.ALARM_UPDATE_SUCCESS, payload: data };
}

export function updateAlarmError(error: any) {
    return { type: ALARMS.ALARM_UPDATE_ERROR, payload: error };
}

export function updateAlarms() {
    return { type: ALARMS.ALARMS_UPDATE };
}

export function updateAlarmsSuccess(data: AlarmList) {
    return { type: ALARMS.ALARMS_UPDATE_SUCCESS, payload: data };
}

export function updateAlarmsError(error: any) {
    return { type: ALARMS.ALARMS_UPDATE_ERROR, payload: error };
}

export function AlarmsAfterUpdate(data: AlarmList) {
    return { type: ALARMS.ALARMS_AFTER_UPDATE, payload: data };
}

/** DELETE */
export function deleteAlarm() {
    return { type: ALARMS.ALARM_DELETE };
}

export function deleteAlarmSuccess(data: AlarmList) {
    return { type: ALARMS.ALARM_DELETE_SUCCESS, payload: data };
}

export function deleteAlarmError(error: any) {
    return { type: ALARMS.ALARM_DELETE_ERROR, payload: error };
}

export function deleteAlarms() {
    return { type: ALARMS.ALARMS_DELETE };
}

export function deleteAlarmsSuccess(data: AlarmList) {
    return { type: ALARMS.ALARMS_DELETE_SUCCESS, payload: data };
}

export function deleteAlarmsError(error: any) {
    return { type: ALARMS.ALARMS_DELETE_ERROR, payload: error };
}